export default "__VITE_ASSET__Bc0KAthY__"